import { useLazyQuery, useMutation } from '@apollo/client';
import LibraryHeader from '../../components/LibraryHeader/LibraryHeader';
import MaterialsContainer from '../../components/MaterialsContainer/MaterialsConatiner';
import FileUpload from '../../components/Popups/FileUpload';
import './ImageMaterial.scss';
import { useCallback, useEffect, useState } from 'react';
import ToasterWithMessage from '../../components/toaster';
import { useLocation, useNavigate } from 'react-router-dom';
import { debounce } from 'lodash';
import Loader from '../../components/Loader/Loader';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import { DELETE_IMAGES_PODCASTS, DELETE_IMAGES_PODCASTS_ADMIN, UPDATE_IMAGES_PODCASTS, UPDATE_IMAGES_PODCASTS_ADMIN, UPLOAD_LIBRARY_IMAGE, UPLOAD_LIBRARY_IMAGE_ADMIN, VIEW_ALL_LIBRARY_IMAGES, VIEW_ALL_LIBRARY_IMAGES_ADMIN } from './api/ImageMaterialQuery';
import { useAppSelector } from '../../redux/app/hooks';
import ImageViewer from '../../components/ImageViewer/ImageViewer';
import { materialsData } from '../../utils/interface';
import { SCHOOL_ADMIN, STUDENT_ROLE } from '../../utils/constants';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { getScreenDimensions } from '../../utils/helper';
import images from '../../assets/images';

const ImageMaterial = () => {
    const [url, setUrl] = useState<string>();
    const [imgFileData, setImgFileData] = useState<materialsData | undefined>();
    const [filename, setFilename] = useState<string>();
    const [fileData, setFileData] = useState<File | null>();
    const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const [openPdf, setOpenPdf] = useState(false);
    const role = useAppSelector((state) => state.auth.role);
    const [imageMaterialsData, setImageMaterialsData] = useState<[materialsData]>();
    const backNavigation = role === SCHOOL_ADMIN  ?  "/admin-materials-upload/materials/images" : role === STUDENT_ROLE ? '/student-classroom/images':'/teacher-classroom/images';
    const [searchValue, setSearchValue] = useState<string>('');
    const [uploadProgress, setUploadProgress] = useState<number>(0);
    const [uploadFailed, setUploadFailed] = useState<boolean>(false);
    const [uploadFileName, setUploadFileName] = useState<string>('');
    const [uploaded, setuploaded] = useState(false);
    const { success, error } = ToasterWithMessage();
    const { state } = useLocation();
    const selectedClassId = useAppSelector((state) => state?.auth?.selectedClassRoomId);
    const selectedLibraryId = localStorage.getItem('selectedLId');
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const [materialAction,setMaterialAction] = useState<string>('');
    const [refetch, SetRefetch] = useState<boolean>(false);
    const navigate = useNavigate();
    const profile = useAppSelector((state) => state.auth.adminProfile);
    const {uploadCloud} = images;
    const selectedClassroomIdAdmin = useAppSelector(
        (state) => state.CommonUpload.classroomId
      );


    const [uploadImageMaterial] = useMutation(UPLOAD_LIBRARY_IMAGE, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.uploadMylibraryImagesAndPodcasts) {
                setFileData(null);
                if (filename) {
                    setUploadFileName(filename);
                }
                setuploaded(true);
                setUploadProgress(100);
                setFilename('');
                setUrl('');
                getAllImageMaterial({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        cId: selectedClassId,
                        limit: null,
                        offset: null,
                        searchInput: `%${searchValue.trim()}%`,
                    }
                });
            }
        },
        onError: (err) => {
            if (filename) {
                setUploadFileName(filename);
            }
            setuploaded(true);
            setUploadProgress(0);
            setUploadFailed(true);
        }
    });

     const [uploadImageMaterialAdmin] = useMutation(UPLOAD_LIBRARY_IMAGE_ADMIN, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.uploadMylibraryImagesBySchoolAdmin) {
                setFileData(null);
                if (filename) {
                    setUploadFileName(filename);
                }
                setuploaded(true);
                setUploadProgress(100);
                setFilename('');
                setUrl('');
                getAllImageMaterialAdmin({
                  variables: {
                    subjectId: selectedSubjectId,
                    searchInput: `%${searchValue.trim()}%`,
                    classroomIds: [selectedClassroomIdAdmin],
                  },
                });
            }
        },
        onError: (err) => {
            if (filename) {
                setUploadFileName(filename);
            }
            setuploaded(true);
            setUploadProgress(0);
            setUploadFailed(true);
        }
    });

    const [getAllImageMaterial, { loading }] = useLazyQuery(VIEW_ALL_LIBRARY_IMAGES, {
        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            if (data?.getMylibraryImagesPodcastsInfo?.nodes) {
                setImageMaterialsData(data?.getMylibraryImagesPodcastsInfo?.nodes);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/images', { state: { title: 'Images' } });
                    } else {
                        navigate('/teacher-classroom/images', { state: { title: 'Images' } });
                    }
                }, 2000);
            }
        }
    });

    const [getAllImageMaterialAdmin, { loading: AdminLoading }] = useLazyQuery(VIEW_ALL_LIBRARY_IMAGES_ADMIN, {
        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            if (data?.getMylibraryImagesForAdmin?.nodes) {
                setImageMaterialsData(data?.getMylibraryImagesForAdmin?.nodes);
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });

    const [readFeed] = useMutation(READ_CLASSROOMUPDATES, {
        fetchPolicy: 'network-only',
        onCompleted : (data) =>{
        },
        onError: (err) =>{
          console.log(err.message)
        }
      })
    
      useEffect(()=>{
    if(role === STUDENT_ROLE){
      if(imageMaterialsData && imageMaterialsData.length > 0){
        imageMaterialsData?.forEach((data) => {
          if (data.feedId) {
            readFeed({
              variables: {
                fId: data.feedId,
                uId: profile?.getCurrentUser?.nodes[0]?.uId
              }
            })
          }
        });
      }
    }
      },[imageMaterialsData, profile?.getCurrentUser?.nodes, readFeed, role])

    const [updateImage] = useMutation(UPDATE_IMAGES_PODCASTS, {
        fetchPolicy: "no-cache",
        onCompleted: () => {
            SetRefetch(!refetch);
            if(materialAction === "share"){
                success("Shared successfully");
            }else if(materialAction === "undoShare"){
                success("Unshared successfully");
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/images', { state: { title: 'Images' } });
                    } else {
                        navigate('/teacher-classroom/images', { state: { title: 'Images' } });
                    }
                }, 2000);
            }
        }
    });

    const [updateImageAdmin] = useMutation(UPDATE_IMAGES_PODCASTS_ADMIN, {
        fetchPolicy: "no-cache",
        onCompleted: () => {
            SetRefetch(!refetch);
            if(materialAction === "share"){
                success("Shared successfully");
            }else if(materialAction === "undoShare"){
                success("Unshared successfully");
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });

    const [deleteImage] = useMutation(DELETE_IMAGES_PODCASTS, {
        fetchPolicy: "no-cache",
        onCompleted: () => {
            SetRefetch(!refetch);
            success("Deleted successfully");
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/images', { state: { title: 'Images' } });
                    } else {
                        navigate('/teacher-classroom/images', { state: { title: 'Images' } });
                    }
                }, 2000);
            }
        }
    });

     const [deleteImageAdmin] = useMutation(DELETE_IMAGES_PODCASTS_ADMIN, {
        fetchPolicy: "no-cache",
        onCompleted: () => {
            SetRefetch(!refetch);
            success("Deleted successfully");
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });

    useEffect(() => {
         if(role === SCHOOL_ADMIN){
         getAllImageMaterialAdmin({
           variables: {
             subjectId: selectedSubjectId,
             searchInput: "%%",
             classroomIds: [selectedClassroomIdAdmin],
           },
         });
        }else{
        getAllImageMaterial({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                cId: selectedClassId,
                limit: null,
                offset: null,
                searchInput: `%${searchValue.trim()}%`,
                isClassroom: role === STUDENT_ROLE ? true : [true, false],
            }
        });
    }
    }, [refetch]);

    useEffect(() => {
        if(role === SCHOOL_ADMIN){
         getAllImageMaterialAdmin({
           variables: {
             subjectId: selectedSubjectId,
             searchInput: '%%',
             classroomIds: [selectedClassroomIdAdmin],
           },
         });
        }
        else{
        getAllImageMaterial({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                cId: selectedClassId,
                limit: null,
                offset: null,
                searchInput: '%%',
                isClassroom: role === STUDENT_ROLE ? true : [true, false],
            }
        })
        }
    }, []);

    useEffect(() => {
        if (fileData && filename && filename !== '' && url) {
            if(role === SCHOOL_ADMIN){
          uploadImageMaterialAdmin({
            variables: {
              files: [
                {
                  filename: filename?.replace(/\.pdf$/, "")?.trim(),
                  filepath: url,
                  filesize: fileData?.size,
                  isClassroom: false,
                  coverImagePath: null,
                  fileDescription: null,
                },
              ],
              classroomIds: [selectedClassroomIdAdmin],
              subjectId: selectedSubjectId,
            },
          });
            }else{
            uploadImageMaterial({
                variables: {
                    cId: selectedClassId,
                    filename: filename?.replace(/\.pdf$/, "")?.trim(),
                    filepath: url,
                    filesize: fileData?.size,
                    isClassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                }
            });
            }
        }
    }, [fileData, filename, url]);

    //To open pdf in detailed view
    const handleOpenFile = (imgData: materialsData) => {
        setOpenPdf(true);
        setImgFileData(imgData);
    }

    //To close pdf detailed view
    const handleClosePdf = () => {
        setOpenPdf(false);
        setImgFileData(undefined);
        if(role === SCHOOL_ADMIN){
         getAllImageMaterialAdmin({
           variables: {
             subjectId: selectedSubjectId,
             searchInput: `%${searchValue.trim()}%`,
            classroomIds: [selectedClassroomIdAdmin],
           },
         });
        }
        else{
        getAllImageMaterial({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                cId: selectedClassId,
                limit: null,
                offset: null,
                searchInput: `%${searchValue.trim()}%`,
                isClassroom: role === STUDENT_ROLE ? true : [true, false],
            }
        });
    }
    }

    //To done actions in materials
    const handleMaterialActions = (data:any,action:string) =>{
        if(action === "share"){
            setMaterialAction("share");
            if(role === SCHOOL_ADMIN){
              updateImageAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pIsClassroom: true,
                    pLType: "Images",
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            updateImage({
                variables:{
                    isClassroom: true,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassId,
                    fId: data?.fileId
                }
            });
            }
        }else if(action === "undoShare"){
            setMaterialAction("undoShare");
             if(role === SCHOOL_ADMIN){
              updateImageAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pIsClassroom: false,
                    pLType: "Images",
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            updateImage({
                variables:{
                    isClassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassId,
                    fId: data?.fileId
                }
            });
            }
        }else if(action === "delete"){
            setMaterialAction('');
            if(role === SCHOOL_ADMIN){
                deleteImageAdmin({
                  variables: {
                    input: {
                      pSubjectId: selectedSubjectId,
                      pFileId: data?.fileId,
                      pLType: "Images",
                      pClassroomIds: [selectedClassroomIdAdmin],
                    },
                  },
                });
            }else{
            deleteImage({
                variables:{
                    cId: selectedClassId,
                    fId: data?.fileId,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                }
            });
            }
        }
    };

    const handleSearchDebounce = useCallback(
        debounce((value) => {
            setSearchValue(value);
            if(role === SCHOOL_ADMIN){
              getAllImageMaterialAdmin({
                variables: {
                  subjectId: selectedSubjectId,
                  searchInput: `%${value.trim()}%`,
                 classroomIds: [selectedClassroomIdAdmin],
                },
              });
            }
        else{
            getAllImageMaterial({
                variables:{
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId:selectedClassId,
                    limit: null,
                    offset: null,
                    searchInput: `%${value.trim()}%`,
                    isClassroom: role === STUDENT_ROLE ? true : [true, false],
                }
            });
        }
        }, 500),
        [getAllImageMaterial]
    );

    const handleOpenUpload = () => {
        setIsUploadOpen(true);
        setOpen(true);
    };

    return (
        <div className={`imageMaterial ${role === SCHOOL_ADMIN ? "schoolAdminMaterials":""}`}>
            <LibraryHeader
                image={openPdf ? '' : state?.imageSrc}
                subject={openPdf ? '' : state?.title}
                backgroundColor={state?.backGroundColor}
                subCategory={openPdf ? '' : 'Images'}
                setIsUploadOpen={setIsUploadOpen}
                openPdf={openPdf}
                onClose={handleClosePdf}
                setOpen={setOpen}
                backNavigation={{ path: backNavigation, state: { title: "Images" } }}
                handleSearchDebounce={handleSearchDebounce}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
            />
            {
                openPdf ?
                    <ImageViewer file={imgFileData?.filepath ? baseUrl + imgFileData?.filepath : ''} imgFileData={imgFileData} onClose={handleClosePdf} type={"Images"} />
                    :
                    <>
                        <div className='imageMaterialBody' style={{height: role=== STUDENT_ROLE? '92%' : ''}}>
                            {
                                loading || AdminLoading ? <Loader bottom='110px' />
                                    :
                                    <MaterialsContainer
                                        subject={state?.title}
                                        subCategory={`Images`}
                                        materialsData={imageMaterialsData}
                                        handleOpenFile={handleOpenFile}
                                        isPdf={false}
                                        handleMaterialActions={handleMaterialActions}
                                    />
                            }
                        </div>
                    </>
            }
            {/* {isUploadOpen && <FileUpload type='image' name='ImageMaterial' setUrl={setUrl} open={open} setOpen={setOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} />} */}
            {isUploadOpen && <FileUpload type='image' name='ImageMaterial' setUrl={setUrl} open={open} setOpen={setOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} setUploadFailed={setUploadFailed} setUploadProgress={setUploadProgress} setuploaded={setuploaded} setUploadFileName={setUploadFileName} />}
            {uploaded && <UploadToaster uploaded={uploaded} setuploaded={setuploaded} uploadProgress={uploadProgress} setUploadProgress={setUploadProgress} fileName={uploadFileName} setUploadFileName={setUploadFileName} uploadFailed={uploadFailed} setUploadFailed={setUploadFailed} />}

             {(getScreenDimensions()?.isMobileScreen && role !== STUDENT_ROLE) && !openPdf &&
                <div className='libraryHeaderUploadContainer'> 
                    <div className='libraryHeaderUpload' onClick={handleOpenUpload}>
                        <img src={uploadCloud} alt="upload" className='uploadImage' />
                    </div>
                </div>}
        </div>
    )
}

export default ImageMaterial;
